import {
  BooleanValidation,
  NumberValidation,
  ObjectValidation,
} from '../../../../utils/component-validations';
import { modifier } from 'ember-modifier';
import { reads } from 'macro-decorators';
import { tracked } from '@glimmer/tracking';
import FlexColumn from '../../layout/flex/column.gjs';
import FlexRow from '../../layout/flex/row.gjs';
import Super from '../../core/base.gjs';
import styles from './base.module.scss';

const ANCHOR_DISTANCE_DEFAULT = 4;

export default class SpdsCoreMenuBase extends Super {
  arguments = [
    new BooleanValidation({ optional: ['animated', 'column', 'fitContent'], required: ['open'] }),
    new NumberValidation({ optional: ['anchorOffset'] }),
    new ObjectValidation({ required: ['anchorElement'] }),
  ];
  baseClass = 'spds-menu';
  classesToMapToArgs = ['animated', 'open'];
  classesToMapToAttrs = ['side'];
  styles = styles;

  @tracked menuElement;
  @tracked side = 'left';

  @reads('args.anchorOffset', ANCHOR_DISTANCE_DEFAULT) anchorDistance;
  @reads('args.column', true) isColumn;

  get anchorBoundingRect() {
    return this.args.anchorElement?.getBoundingClientRect();
  }

  get canBePositioned() {
    return !!this.args.anchorElement && !!this.baseElement;
  }

  get component() {
    return this.isColumn ? FlexColumn : FlexRow;
  }

  get parentBoundingRect() {
    return this.args.anchorElement?.parentElement?.getBoundingClientRect();
  }

  setMenuPosition = modifier(() => {
    if (!this.canBePositioned) return;

    let anchorBottom = this.anchorBoundingRect?.bottom;
    let menuRight = this.anchorBoundingRect?.x + this.baseElement?.getBoundingClientRect()?.width;
    let parentTop = this.parentBoundingRect?.top || 0;
    let top = anchorBottom - parentTop + this.anchorDistance;

    this.side = menuRight > window.innerWidth ? 'right' : 'left';
    this.baseElement.style.top = `${top}px`;
  });

  <template>
    <this.component
      @absolute={{true}}
      @fitContentWidth={{@fitContent}}
      aria-expanded={{@open}}
      class={{this.classes}}
      data-test-spds-menu
      id={{this.id}}
      role="listbox"
      {{this.setupComponent}}
      {{this.setMenuPosition}}
      {{this.validateArguments}}
      ...attributes
    >
      {{yield}}
    </this.component>
  </template>
}
